import { SVGProps, Ref, forwardRef } from 'react';

export const EnvelopeOpenedFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.8 1h12.4v10.65L12 14.226 5.8 11.65zM4 10.903V5.469C2.017 6.072.885 7.298.361 9.391zm-3.93.316Q0 12.044 0 13v2c0 6 2 8 8 8h8c6 0 8-2 8-8v-2q0-.956-.07-1.78L12 16.174zM23.64 9.391c-.524-2.093-1.656-3.32-3.639-3.922v5.434zm-8.139-.49h-7V7.1h7z"
                fill="currentColor"
            />
        </g>
    </svg>
));
EnvelopeOpenedFilledSize24Glyph.displayName = 'EnvelopeOpenedFilledSize24Glyph';
